import React from 'react'
import CopyPlanUpload from '../../plan/CopyPlanUpload'
import V3PlanRouteShell from './V3PlanRouteShell'

export default function V3CopyPlanUploadPage() {
  return (
    <V3PlanRouteShell>
      <CopyPlanUpload visualVariant="v3" />
    </V3PlanRouteShell>
  )
}

